import React from "react";

import Popover from "@mui/material/Popover";

import { BALANCE_PRIVATE_MODE_SX } from "./balance-display.component";

type BalanceExpanderProps = {
  open: boolean;
  anchorEl: HTMLElement | null;
  children: React.ReactNode;
  isPrivateMode?: boolean;
  onClose: () => void;
};

const paperSx = {
  minWidth: "300px",
  px: 1.5,
  py: 1.5,
  border: "solid 1px #ccc",
  overflow: "visible",
  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
  mt: 1.5,
  ml: -5.5,
  "& .MuiAvatar-root": {
    width: 32,
    height: 32,
    ml: -0.5,
    mr: 1
  },
  "&:before": {
    content: '""',
    display: "block",
    position: "absolute",
    top: 0,
    left: 14,
    width: 10,
    height: 10,
    bgcolor: "background.paper",
    transform: "translateY(-50%) rotate(45deg)",
    zIndex: 0
  }
};

export default function BalanceExpander({
  children,
  open,
  anchorEl,
  onClose,
  isPrivateMode
}: BalanceExpanderProps) {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      slotProps={{
        paper: {
          elevation: 0,
          sx: isPrivateMode
            ? { ...paperSx, ...BALANCE_PRIVATE_MODE_SX }
            : paperSx
        }
      }}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left"
      }}
    >
      {children}
    </Popover>
  );
}
